export * from './event-details-mobile'
import {
  getEventDescription,
  getEventMainImage,
  getEventTitle,
  hasSeatingPlan,
  isTicketed,
} from '@wix/wix-events-commons-statics'
import {withTranslation} from '@wix/yoshi-flow-editor'
import {isAboutSectionVisible, isMapVisible} from '../../selectors/event'
import {isGroupActivityVisible} from '../../selectors/groups'
import {isMembersVisibleWithGuests} from '../../selectors/members'
import {isMoreDatesButtonVisible, isMoreDatesLabelVisible} from '../../selectors/occurrences'
import {isScheduleVisible, isSideBySideHeaderLayout} from '../../selectors/settings'
import {getTickets} from '../../selectors/tickets'
import {DetailsPageAppProps} from '../app/interfaces'
import {connect} from '../runtime-context/context'
import {EventDetailsMobile as Presentation} from './event-details-mobile'
import {EventDetailsOwnProps, EventDetailsRuntimeProps} from './interfaces'

const mapRuntime = ({
  state,
  actions: {handleRSVP, detailsPageLoaded, openSeatingPlan},
}: DetailsPageAppProps): EventDetailsRuntimeProps => {
  const event = state.event
  const componentSettings = state.component.settings
  const scheduleVisible = isScheduleVisible(state)
  const ticketedEvent = isTicketed(event)

  return {
    eventTitle: getEventTitle(event),
    eventDescription: getEventDescription(event),
    mainImage: getEventMainImage(event),
    componentSettings,
    membersVisible: isMembersVisibleWithGuests(state),
    mapVisible: isMapVisible(state),
    aboutSectionVisible: isAboutSectionVisible(state),
    handleRSVP,
    detailsPageLoaded,
    openSeatingPlan,
    scheduleVisible,
    sideBySideHeaderLayout: isSideBySideHeaderLayout(componentSettings),
    moreDatesVisible: isMoreDatesLabelVisible(state),
    moreDatesButtonVisible: isMoreDatesButtonVisible(state),
    groupVisible: isGroupActivityVisible(state),
    hasTickets: ticketedEvent && Boolean(getTickets(state).length),
    ticketedEvent,
    withSeatingPlan: hasSeatingPlan(event),
  }
}

export const EventDetailsMobile = withTranslation()(
  connect<EventDetailsOwnProps, EventDetailsRuntimeProps>(mapRuntime)(Presentation),
)
export * from './interfaces'
